import React, { useEffect, useState } from "react";
import { getDeliveredOrdersApi, exportOrder } from "../../api/orders";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const DeliveredOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [loading, setLoading] = useState(false);

  const [tableMessage, setTableMessage] = useState("");
  useEffect(() => {
    fetchDeliveredOrders();
  }, []);
  const fetchDeliveredOrders = async (from = "", to = "") => {
    try {
      setLoading(true);
      setTableMessage("");
      const response = await getDeliveredOrdersApi({
        fromDate: from,
        toDate: to,
      });
      const orderList = response?.data || response?.orders || [];
      let filteredOrders = orderList;
      // Date range filter
      if (from && to) {
        const startDate = new Date(from);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(to);
        endDate.setHours(23, 59, 59, 999);
        filteredOrders = orderList.filter((order) => {
          const orderDate = new Date(order.createdAt);
          return orderDate >= startDate && orderDate <= endDate;
        });
      }
      setOrders(filteredOrders);
      if (filteredOrders.length === 0) {
        setTableMessage("No Delivered Orders Found");
      }
    } catch (error) {
      console.error(error);
      setOrders([]);
      setTableMessage(
        error?.response?.status === 404 ? "No Delivered Orders Found" : "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };
  const handleApplyFilter = () => {
    if (fromDate && toDate && fromDate > toDate) {
      setOrders([]);
      setTableMessage("From Date should not be greater than To Date");

      return;
    }
    const from = fromDate ? new Date(fromDate).toISOString().split("T")[0] : "";
    const to = toDate ? new Date(toDate).toISOString().split("T")[0] : "";
    fetchDeliveredOrders(from, to);
  };

  const handleExportOrder = async () => {
    try {
      const response = await exportOrder();
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "orders.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    }
  };
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "-";
    const day = ("0" + d.getDate()).slice(-2);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <div className="d-flex gap-2 align-items-center justify-content-end pb-3">
          <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            className="form-control"
          />
          <span className="fw-bold">To</span>
          <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            className="form-control"
          />
          <button className="btn btn-primary" onClick={handleApplyFilter} disabled={loading}>
            {loading ? "Loading..." : "Apply Filter"}
          </button>
          <button className="btn btn-success" onClick={handleExportOrder}>
            Export CSV
          </button>
        </div>

        <table className="table table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th className="text-dark fw-bold"> # </th>
              <th className="text-dark fw-bold">Order ID</th>
              <th className="text-dark fw-bold">Order Date</th>
              <th className="text-dark fw-bold">Dispatch Date</th>
              <th className="text-dark fw-bold">Customer Name</th>
              <th className="text-dark fw-bold">Product Name</th>
              <th className="text-dark fw-bold">Variation</th>
              <th className="text-dark fw-bold">Total Amount</th>
              <th className="text-dark fw-bold                            ````````````">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : orders.length > 0 ? (
              orders.map((order, index) => (
                <tr key={order._id}>
                  <td>{index + 1}</td>
                  <td> {order.orderId} </td>
                  <td>{formatDate(order.createdAt)}</td>
                  <td>{formatDate(order.shipment?.dispatch_date)} </td>
                  <td>{order.address?.fullName}</td>
                  <td> {order.items?.[0]?.name} </td>
                  <td>
                    {order.items?.[0]?.variationName ||
                      order.items?.[0]?.selections?.variationId?.name ||
                      "N/A"}
                  </td>
                  <td>₹{order.total} </td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm np-table-action-btn"
                      onClick={() =>
                        navigate("/orders/view", {
                          state: { orderId: order._id },
                        })
                      }
                    >
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {tableMessage || "No Delivered Orders Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeliveredOrders;
